export const platformItems = [
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}product/jainam/`, text: "Jainam" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}product/jplus/`, text: "Jainam Assist" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}product/jainam-api/`, text: "API" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}product/jainam-strike/`, text: "Strike" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}product/smartgreek/`, text: "SmartGreek" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}product/smart-rms/`, text: "SmartRMS" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}product/smart-delta/`, text: "SmartDelta" },
];

export const investTradeItems = [
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}stocks/`, text: "Stocks" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}margin-trading-facility/`, text: "Margin Trading Facility" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}futures-trading/`, text: "Futures Trading" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}options-trading/`, text: "Options Trading" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}mutual-funds/`, text: "Mutual Funds" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}nfo/`, text: "NFO" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}debt/`, text: "Debt Products" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}ipo/`, text: "IPO" },
];

export const InvestmentService = [
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}pms/`, text: "PMS" },
]
export const researchItems = [
  { href: "https://jainam.in/jainam-reports/", text: "Research Updates" },
];
export const noticeBoardItems = [
  // { href: '#', text: 'Updates' },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}general-updates/`, text: "General Updates" },
  { href: "https://jainam.in/nse-holidays/", text: "Holiday Calendar" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}circulars/`, text: "Circulars" },
];

export const servicesLinks = [
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}clearing-services/`, text: 'Clearing Services' },
];